import type { RefObject } from 'react'
import { isStorageAvailable } from 'src/utils/isStorageAvailable'

interface Props {
  positions: Positions
  width: number
  height?: number | null
  modalHeight?: number
  isMobile: boolean
  headerSize?: number
}

interface Positions {
  topPosition: number
  leftPosition: number
}

export const validatePositions = (
  componentSize: number,
  { positions, width, height, headerSize }: Props
): boolean => {
  const { topPosition, leftPosition } = positions

  if (height && headerSize) {
    if (topPosition < headerSize || topPosition > height - componentSize) {
      return false
    }
  }

  if (leftPosition < 0 || leftPosition > width) {
    return false
  }

  return true
}

export const openModal = (element: RefObject<HTMLDivElement>): void => {
  if (!element?.current) {
    return
  }

  element?.current?.classList?.add('active')
}

export const closeModal = (element: RefObject<HTMLDivElement>) => {
  if (!element?.current) {
    return
  }

  element?.current?.classList?.remove('active')
}

export const saveIconPosition = (key: string, item: Positions) => {
  if (typeof window !== 'undefined' && isStorageAvailable()) {
    sessionStorage.setItem(key, JSON.stringify(item))
  }
}
